export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "nothing_to_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rien à signaler"])}
      },
      "en": {
        "nothing_to_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nothing to report"])}
      }
    }
  })
}
